<div *ngIf="plannedSessions && plannedSessions.length > 0">
    <h3>{{ 'training-detail.planned-session-list.header' | translate }}</h3>
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th>
                    {{
                        'training-detail.planned-session-list.date' | translate
                    }}
                </th>
                <th *ngIf="!forTraining">
                    {{
                        'training-detail.planned-session-list.training'
                            | translate
                    }}
                </th>
                <th>
                    {{
                        'training-detail.planned-session-list.trainer'
                            | translate
                    }}
                </th>
                <th>
                    {{
                        'training-detail.planned-session-list.agency'
                            | translate
                    }}
                </th>
                <th></th>
            </tr>
        </thead>
        <tbody *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SESSION_PLANNER']">
            <tr
                *ngFor="let plannedSession of plannedSessions"
                uiSref="planned-session-detail"
                [uiParams]="{ id: plannedSession.id, trainingId: training.id }"
            >
                <td>
                    {{ plannedSession.startDate | date: 'dd MMMM yyyy (EEEE)' }}
                </td>
                <td *ngIf="!forTraining">{{ plannedSession.trainingTitle }}</td>
                <td>
                    {{ plannedSession.trainerLastName }}
                    {{ plannedSession.trainerFirstName }}
                </td>
                <td>{{ 'global.agencies.' + plannedSession.agencyName | translate }}</td>
                <td
                    (click)="showModal(deleteModal, plannedSession)"
                    class="remove-column"
                >
                    <button class="btn btn-default fa fa-trash-o"></button>
                </td>
            </tr>
        </tbody>
        <tbody
            *ngIf="
                currentUserHasNotRoles([
                    'ROLE_ADMIN',
                    'ROLE_SESSION_PLANNER'
                ]) === true
            "
        >
            <tr
                *ngFor="let plannedSession of plannedSessions"
                style="cursor: pointer;"
            >
                <td>
                    {{ plannedSession.startDate | date: 'dd MMMM yyyy (EEEE)' }}
                </td>
                <td *ngIf="!forTraining">{{ plannedSession.trainingTitle }}</td>
                <td>
                    {{ plannedSession.trainerLastName }}
                    {{ plannedSession.trainerFirstName }}
                </td>
                <td>{{ plannedSession.agencyName }}</td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>

<div *ngIf="!plannedSessions || plannedSessions.length === 0">
    <h3 class="no-session">Pas de sessions planifiées</h3>
</div>

<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">
            Etes-vous sur de vouloir supprimer cette session ?
        </h4>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="closeModal()">
            Annuler
        </button>
        <button type="button" class="btn btn-primary" (click)="remove()">
            Supprimer
        </button>
    </div>
</ng-template>

<planning-detail
    *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_SESSION_PLANNER']"
    [new]="true"
    [training]="training"
    (added)="saved()"
    class="psForm"
>
</planning-detail>

<div *ngIf="success" class="alert alert-success">
    <strong>Réussi !</strong>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/planning/planning.component.html